import React from 'react';
import ReactDOM from 'react-dom';
import FormControl from './FormControl';
import Select from 'react-select';
import { debounce, isEqual } from 'lodash';
import { checkError, getSelectData, selectOnChange, onFocus, multiSelectPropTypes, defaultMultiselectProps, translationProps, rendererProps, autoComplete } from '../ControlHelpers/SelectUtils.js';

export default class SelectAsyncControl extends FormControl {
  static propTypes = multiSelectPropTypes;
  static defaultProps = defaultMultiselectProps;

  constructor(props) {
    super(props);
    let value = props.initialData;
    if (value && !value.display) {
      if (props.buildDisplay) {
        value.display = props.buildDisplay(value);
      } else {
        value.display = value[props.displayProperty];
      }
    }
    this.state = { value, isLoading: false };
    this.debouncedGetData = debounce(this.getData, props.valueChangeDelay, { leading: false, trailing: true });

    if (value && value.display) {
      this.onChange(this.state.value);
    }

  }

  componentWillReceiveProps(newProps) {
    if (!isEqual(this.props.filters, newProps.filters) || this.props.dataUrl !== newProps.dataUrl) {
      this.onChange();
    }
    if (newProps.valueOverride && newProps.dataValue !== this.state.value) {
      this.onChange(newProps.dataValue, true)
    }
  }

  onChange = (val, skipValueChange) => {
    const value = selectOnChange(val, this.props, this.select, skipValueChange);
    this.setState({ ...this.state, value });
  }

  getData = async (input, callback) => {
    this.setState({ isLoading: true });
    const options = await getSelectData(input, this.props);
    if (this.props.defaultOptions) {
      options.unshift(...this.props.defaultOptions);
    }
    this.setState({ isLoading: false });
    callback(null, { options });
  }

  onFocus = (e) => {
    onFocus(e, this.props);
  }

  checkAndLoadOptions = (input, callback) => {
    if (!input && this.props.requireInput) {
      return Promise.resolve({ options: [] });
    } else {
      this.debouncedGetData(input, callback);
    }
  };

  onBlur = () => {
    if (typeof this.props.onBlur === 'function') {
      this.props.onBlur(this.state.value);
    }
    this.checkError();
  };

  isValid = () => {
    return this.input.validity.valid;
  };

  onRef = (select) => {
    this.select = select;
    if (this.select) {
      this.input = ReactDOM.findDOMNode(this.select).querySelector('input');
    }
  }

  checkError() {
    checkError(this.props, this.select);
  }

  render() {
    let { setError, name, cacheEnabled, creatable, ...props } = this.props;  // eslint-disable-line no-unused-vars
    name = this.props.multi ? name + '[]' : name;
    const SelectedComponent = creatable ? Select.AsyncCreatable : Select.Async;
    return (
      <SelectedComponent
        {...props}
        {...translationProps}
        {...rendererProps(this.props.multi, this.props)}
        aria-labelledby={`${this.props.name}-label`}
        cache={cacheEnabled}
        inputProps={autoComplete(this.props)}
        isLoading={this.state.isLoading}
        labelKey="display"
        loadOptions={this.checkAndLoadOptions}
        name={name}
        onBlur={this.onBlur}
        onChange={this.onChange}
        onOpen={this.onOpen}
        ref={this.onRef}
        scrollMenuIntoView={false}
        closeOnSelect={!this.props.multi}
        removeSelected={false}
        value={this.state.value}
        valueKey={this.props.valueProperty}
      />
    );
  }
}
